/* eslint-disable import/no-unresolved */

import { h } from 'vue';
import { createVueApp } from '@vuejs/entry';
import { sharedPinia } from '@vuejs/pinia';

/*
Landing High Jewellery. Tresc jest w Twigu; tu tylko:
- kafle stalej oferty (ProductsSlider, te same co w ramkach rekomendacji),
- otwieranie formularza prywatnej prezentacji z przyciskow data-hj-lead.

Offcanvas sklepu (useSharedOffcanvas) zyje w bundlu vue.js, wiec otwieramy go
zdarzeniem na window, a nie importem composable (osobny bundel = osobny stan).
*/
const LEAD_OFFCANVAS = 'lead/HighJewelleryOffcanvas';

async function mountProducts(root) {
    const mount = root.querySelector('[data-hj-products]');
    const productIds = (mount?.dataset.hjProducts ?? '').split(',').filter(Boolean);

    if (!productIds.length) {
        return;
    }

    const { default: ProductsSlider } = await import(
        /* webpackChunkName: "ProductsSlider" */ '@vuejs/components/recommendations/ProductsSlider.vue'
    );

    // createVueApp nie przyjmuje propsow roota, wiec owijamy komponent renderem.
    const app = createVueApp({ render: () => h(ProductsSlider, { productIds }) });

    // AsyncProductItem w srodku siega po useAuthStore.
    app.use(sharedPinia);
    app.mount(mount);
}

function bindLeadButtons(root) {
    root.addEventListener('click', (event) => {
        if (!event.target.closest('[data-hj-lead]')) {
            return;
        }

        window.dispatchEvent(
            new CustomEvent('open-shared-offcanvas', { detail: { name: LEAD_OFFCANVAS } })
        );
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('.high-jewellery');

    if (!root) {
        return;
    }

    bindLeadButtons(root);
    mountProducts(root);
});
